import { useToast } from "@chakra-ui/react";
import { transferAllIn } from "../../../../api/postApi";
import {
  TRANSFER_PENDING,
  TRANSFER_READY,
} from "../../../../redux/action/member/memberAction";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useTransferMode from "../../../../hook/useTransferMode";

/**
 * 自定義 hook 用於處理轉點邏輯，此功能僅有在轉帳錢包模式下才會啟用
 * @warning 此功能目前先在測試階段，提供部分用戶使用
 * @description 處理轉點邏輯的 hook
 * @returns {function} handleTransferAllIn - 處理轉點的函數
 */
export const useTransferInGameHandler = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const dispatch = useDispatch();

  const toast = useToast();

  const location = useLocation();

  const gameConfig = useSelector((state) => state.isGameConfig);
  const isMemberInfo = useSelector((state) => state.isMemberInfo);

  const { testFunction } = isMemberInfo || {}; //是否可以用此功能

  const { game_platform } = gameConfig || {}; //取game_platform

  const inGameBox = location.pathname.includes("gamebox");

  /**
   * @description 檢查是否處於轉帳錢包模式
   */
  const isTransferMode = useTransferMode();

  if (!isTransferMode || !testFunction) {
    return { handleTransferAllIn: () => {} }; // 如果不是轉帳錢包模式，返回空函數
  }
  /**
   * 處理轉點邏輯的函數
   * @param {Object} params - 參數物件
   * @param {function} params.handleCancel - 取消處理函數
   * @param {function} params.setButtonLoading - 設置按鈕載入狀態函數
   */
  const handleTransferAllIn = async ({
    handleCancel,
    setButtonLoading,
  } = {}) => {
    // 防呆處理：確保傳入的函數存在且為函數類型
    const safeHandleCancel =
      typeof handleCancel === "function"
        ? handleCancel
        : () => {
            console.warn(
              "handleCancel function is not provided or not a function"
            );
          };

    const safeSetButtonLoading =
      typeof setButtonLoading === "function"
        ? setButtonLoading
        : (loading) => {
            console.warn(
              "setButtonLoading function is not provided or not a function, loading state:",
              loading
            );
          };
    if (inGameBox) {
      await transferAllIn({ platform: game_platform })
        .then((res) => {
          const { code, request_id } = res;
          switch (code) {
            //200為成功
            case 200:
              dispatch(TRANSFER_READY());

              safeHandleCancel();
              toast({
                title: i18n("提醒您"),
                description: i18n("點數轉入成功，請確認遊戲餘額"),
                status: "success",
                duration: 5000,
                isClosable: true,
                position: "top",
              });
              return;
            //101為存款失敗，將會背景loading，等待websocket回傳結果
            case 101:
              localStorage.setItem("transfer_in_game_request_id", request_id);
              dispatch(TRANSFER_PENDING());

              safeHandleCancel();

              return;
            //102為交易處理中，代表已經有轉點在進行中，可能發生於跨裝置，因為會將單號寫入localStorage，若處理中的話，將回傳的單號再透過websocket傳給後端，等待後端反饋
            case 102:
              localStorage.setItem("transfer_in_game_request_id", request_id);
              dispatch(TRANSFER_PENDING());

              safeHandleCancel();
              return toast({
                title: i18n("提醒您"),
                description: i18n(
                  "您的上一筆訂單未完成，請耐心等候，我們正在為您處理"
                ),
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "top",
              });
            case 103:
              localStorage.removeItem("transfer_in_game_request_id");
              dispatch(TRANSFER_READY());
              safeHandleCancel();
              return;
            default:
              safeHandleCancel();
              return;
          }

          //404為餘額為0時會出現，需要重整
        })
        .finally(() => {
          safeSetButtonLoading(false);
        });
    }
    return;
  };

  return { handleTransferAllIn };
};
